import { PROCESS_STEPS, GALLERY } from '../data/content';
import { MaskedRevealOnView, FadeUp } from './motion/Reveal';
import { motion } from 'framer-motion';

const Process = () => {
    return (
        <section id="process" data-testid="process-section" className="bg-[#F4F5F6] text-[#0A0A0B] py-28 md:py-40">
            <div className="mx-auto max-w-[1500px] px-6 md:px-10">
                <div className="grid grid-cols-12 gap-6 mb-16">
                    <div className="col-span-12 md:col-span-4">
                        <span className="overline text-[#FF3B00]">Process · 03</span>
                    </div>
                    <div className="col-span-12 md:col-span-8">
                        <MaskedRevealOnView
                            className="h-display text-[10vw] md:text-[6vw] leading-[0.9]"
                            lines={['From billet', 'to finished bar.']}
                        />
                        <FadeUp delay={0.15}>
                            <p className="mt-6 max-w-2xl text-[#0A0A0B]/70 text-base md:text-lg leading-relaxed">
                                Six controlled stages. Every step logged, every batch traceable to the heat number.
                            </p>
                        </FadeUp>
                    </div>
                </div>

                {/* Bento gallery */}
                <div className="grid grid-cols-12 gap-4 md:gap-5 mb-24">
                    <motion.div
                        initial={{ opacity: 0, scale: 1.03 }}
                        whileInView={{ opacity: 1, scale: 1 }}
                        viewport={{ once: true, margin: '-60px' }}
                        transition={{ duration: 0.9 }}
                        className="col-span-12 md:col-span-8 aspect-[16/10] relative overflow-hidden clip-corner"
                    >
                        <img src={GALLERY[0].url} alt={GALLERY[0].label} className="w-full h-full object-cover" />
                        <div className="absolute inset-0" style={{ background: 'radial-gradient(ellipse at center, transparent 30%, rgba(0,0,0,0.5) 90%)' }} />
                        <div className="absolute bottom-5 left-5 overline text-white">{GALLERY[0].label}</div>
                    </motion.div>
                    <motion.div
                        initial={{ opacity: 0, scale: 1.03 }}
                        whileInView={{ opacity: 1, scale: 1 }}
                        viewport={{ once: true, margin: '-60px' }}
                        transition={{ duration: 0.9, delay: 0.1 }}
                        className="col-span-12 md:col-span-4 aspect-[16/10] md:aspect-auto relative overflow-hidden clip-notch"
                    >
                        <img src={GALLERY[1].url} alt={GALLERY[1].label} className="w-full h-full object-cover" />
                        <div className="absolute inset-0 bg-black/25" />
                        <div className="absolute bottom-5 left-5 overline text-white">{GALLERY[1].label}</div>
                    </motion.div>
                    <motion.div
                        initial={{ opacity: 0, scale: 1.03 }}
                        whileInView={{ opacity: 1, scale: 1 }}
                        viewport={{ once: true, margin: '-60px' }}
                        transition={{ duration: 0.9, delay: 0.05 }}
                        className="col-span-6 md:col-span-4 aspect-square relative overflow-hidden clip-notch"
                    >
                        <img src={GALLERY[2].url} alt={GALLERY[2].label} className="w-full h-full object-cover" />
                        <div className="absolute inset-0 bg-black/30" />
                        <div className="absolute bottom-4 left-4 overline text-white">{GALLERY[2].label}</div>
                    </motion.div>
                    <motion.div
                        initial={{ opacity: 0, scale: 1.03 }}
                        whileInView={{ opacity: 1, scale: 1 }}
                        viewport={{ once: true, margin: '-60px' }}
                        transition={{ duration: 0.9, delay: 0.1 }}
                        className="col-span-6 md:col-span-4 aspect-square relative overflow-hidden clip-corner"
                    >
                        <img src={GALLERY[3].url} alt={GALLERY[3].label} className="w-full h-full object-cover" />
                        <div className="absolute inset-0 bg-black/30" />
                        <div className="absolute bottom-4 left-4 overline text-white">{GALLERY[3].label}</div>
                    </motion.div>
                    <motion.div
                        initial={{ opacity: 0, scale: 1.03 }}
                        whileInView={{ opacity: 1, scale: 1 }}
                        viewport={{ once: true, margin: '-60px' }}
                        transition={{ duration: 0.9, delay: 0.15 }}
                        className="col-span-12 md:col-span-4 aspect-square relative overflow-hidden clip-notch"
                    >
                        <img src={GALLERY[4].url} alt={GALLERY[4].label} className="w-full h-full object-cover" />
                        <div className="absolute inset-0 bg-black/30" />
                        <div className="absolute bottom-4 left-4 overline text-white">{GALLERY[4].label}</div>
                    </motion.div>
                </div>

                {/* Process step grid */}
                <div className="border-t border-[#0A0A0B]/15 grid grid-cols-1 md:grid-cols-3">
                    {PROCESS_STEPS.map((s, i) => (
                        <motion.div
                            key={s.n}
                            initial={{ opacity: 0, y: 30 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true, margin: '-40px' }}
                            transition={{ duration: 0.7, delay: (i % 3) * 0.08 }}
                            className={`p-6 md:p-10 border-b md:border-r border-[#0A0A0B]/15 last:border-b-0 ${i % 3 === 2 ? 'md:border-r-0' : ''}`}
                        >
                            <div className="flex items-baseline gap-4 mb-4">
                                <div className="h-display text-3xl md:text-5xl text-[#FF3B00]">{s.n}</div>
                                <div className="overline text-[#0A0A0B]/50">Stage {s.n}</div>
                            </div>
                            <div className="h-display text-2xl md:text-3xl mb-3">{s.title}</div>
                            <p className="text-[#0A0A0B]/70 leading-relaxed text-sm md:text-base">{s.body}</p>
                        </motion.div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default Process;
